// Etiquetas/badges y helpers compartidos por las secciones de Mi Competencia.
// Extraído de index.tsx por ENG-LOC-01.
import type { AssessmentStatus, CorrectiveActionStatus } from '@/types';

// Competency category labels come from the configurable system_categories via
// useCategoryLabel('competency_category') — never a hardcoded map, so admin-created
// categories never render as raw slugs (UX-COPY-01).

export const DECLARATION_TYPE_BADGES: Record<string, string> = {
  initial: 'bg-blue-100 text-blue-700',
  renewal: 'bg-purple-100 text-purple-700',
  maintenance: 'bg-green-100 text-green-700',
};

export const DECLARATION_TYPE_LABELS: Record<string, string> = {
  initial: 'Inicial',
  renewal: 'Renovación',
  maintenance: 'Mantenimiento',
};

export const DECLARATION_STATUS_BADGES: Record<string, string> = {
  pending: 'bg-amber-100 text-amber-700',
  issued: 'bg-green-100 text-green-700',
  active: 'bg-green-100 text-green-700',
  revoked: 'bg-red-100 text-red-700',
  expired: 'bg-gray-100 text-gray-600',
};

export const DECLARATION_STATUS_LABELS: Record<string, string> = {
  pending: 'Pendiente',
  issued: 'Emitida',
  active: 'Activa',
  revoked: 'Revocada',
  expired: 'Vencida',
};

export const ASSESSMENT_TYPE_BADGES: Record<string, string> = {
  initial: 'bg-blue-100 text-blue-700',
  periodic: 'bg-purple-100 text-purple-700',
  post_training: 'bg-amber-100 text-amber-700',
  probation: 'bg-cyan-100 text-cyan-700',
  competency_check: 'bg-teal-100 text-teal-700',
};

export const ASSESSMENT_TYPE_LABELS: Record<string, string> = {
  initial: 'Inicial',
  periodic: 'Periódica',
  post_training: 'Post-capacitación',
  probation: 'Período de prueba',
  competency_check: 'Evaluación de competencia',
};

export const ASSESSMENT_STATUS_BADGES: Record<AssessmentStatus, string> = {
  pending: 'bg-blue-100 text-blue-700',
  in_progress: 'bg-amber-100 text-amber-700',
  completed: 'bg-green-100 text-green-700',
};

export const ASSESSMENT_STATUS_LABELS: Record<AssessmentStatus, string> = {
  pending: 'Pendiente',
  in_progress: 'En Progreso',
  completed: 'Completada',
};

export const TRIGGER_BADGES: Record<string, string> = {
  assessment_failed: 'bg-red-100 text-red-700',
  quiz_failed: 'bg-amber-100 text-amber-700',
  manual: 'bg-gray-100 text-gray-600',
  overdue_training: 'bg-orange-100 text-orange-700',
  quiz_failure: 'bg-amber-100 text-amber-700',
  assessment_failure: 'bg-red-100 text-red-700',
};

export const TRIGGER_LABELS: Record<string, string> = {
  assessment_failed: 'Evaluación reprobada',
  quiz_failed: 'Quiz reprobado',
  manual: 'Manual',
  overdue_training: 'Capacitación vencida',
  quiz_failure: 'Quiz reprobado',
  assessment_failure: 'Evaluación reprobada',
};

export const CA_STATUS_BADGES: Record<CorrectiveActionStatus, string> = {
  open: 'bg-red-100 text-red-700',
  in_progress: 'bg-amber-100 text-amber-700',
  resolved: 'bg-green-100 text-green-700',
};

export const CA_STATUS_LABELS: Record<CorrectiveActionStatus, string> = {
  open: 'Abierta',
  in_progress: 'En Progreso',
  resolved: 'Completada',
};

export function isOverdue(dueDate: string | null, status: CorrectiveActionStatus): boolean {
  if (!dueDate || status === 'resolved') return false;
  return new Date(dueDate).getTime() < Date.now();
}
